import React from 'react';
import RetroButton from '../ui/RetroButton';
import RetroBadge from '../ui/RetroBadge';

const Hero = () => {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/e80eb4a41c317bb5346a84936eb4292e.png";
  
  return (
    <section className="relative overflow-hidden border-b-4 border-retro-brown bg-retro-teal pb-20 pt-16 lg:pt-24 lg:pb-32">
      <div className="absolute top-10 left-10 w-32 h-32 bg-retro-yellow rounded-full border-4 border-retro-brown mix-blend-multiply opacity-50 blur-sm"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10 flex flex-col lg:flex-row items-center gap-16">
        <div className="flex-1 text-center lg:text-left">
          <RetroBadge text="West Valley Homeowner's Guide" color="bg-retro-cream" rotation="-rotate-3" className="mb-8" />
          
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[0.9] tracking-tighter uppercase mb-8 text-retro-cream drop-shadow-[4px_4px_0_rgba(58,44,39,1)]">
            10,000 Homes.<br/>
            <span className="text-retro-yellow">One Business<br/>Per Category.</span>
          </h1>
          
          <p className="font-body text-xl md:text-2xl font-bold bg-retro-cream text-retro-brown p-8 border-4 border-retro-brown rounded-[2rem] shadow-retro inline-block mb-10 max-w-2xl leading-tight">
            Become the trusted local business West Valley homeowners already recognize. A premium 9" × 12" guide placed directly into 10,000 homes.
          </p>
          
          <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
            <RetroButton variant="primary" className="!px-10">Claim Your Category</RetroButton>
            <RetroButton variant="light">View 9" x 12" Layout</RetroButton>
          </div>
        </div>

        <div className="flex-1 w-full max-w-lg relative">
          <div className="bg-retro-cream border-4 border-retro-brown rounded-[2rem] p-4 shadow-[16px_16px_0px_0px_rgba(58,44,39,1)] transform rotate-2 transition-transform hover:rotate-0 duration-300">
            <div className="border-4 border-retro-brown rounded-xl overflow-hidden bg-white aspect-[3/4] relative flex flex-col">
              <div className="bg-retro-yellow p-6 border-b-4 border-retro-brown flex flex-col items-center text-center">
                <img src={logoUrl} alt="Logo" className="h-16 w-auto object-contain mb-3" />
                <span className="font-display text-xl uppercase tracking-tighter">Community Spotlight</span>
                <span className="font-body font-black text-[10px] bg-retro-brown text-white px-4 py-1 rounded-full uppercase tracking-widest mt-2">
                   WEST VALLEY EDITION
                </span>
              </div>
              <div className="flex-1 flex items-center justify-center p-8 bg-gray-50">
                <div className="text-center">
                  <div className="w-20 h-20 bg-retro-teal/20 rounded-full border-4 border-dashed border-retro-brown/30 flex items-center justify-center mx-auto mb-4">
                    <span className="font-display text-2xl text-retro-brown">9x12</span>
                  </div>
                  <p className="font-display text-2xl uppercase text-retro-brown">Premium Format</p>
                  <p className="font-body font-bold text-gray-500 text-sm">Oversized & Unmissable</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;